import { styled } from 'baseui'
import { FlexBetween, FlexCenterY } from '@/shared/theme/styled-components'

export const StyledContainer = styled('div', {
  width: '100%',
  padding: '0',
  paddingBottom: '0.4rem',
})

export const StyledTopContainer = styled('div', {
  width: '100%',
  padding: '1rem',
})

export const StyledHeader = styled(FlexBetween, {})

export const StyledTitle = styled('h3', {
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
  fontWeight: '600',
  fontSize: '1.125rem',
  lineHeight: '160%',
  color: '#343535',
})

export const OuterCard = styled('div', {
  backgroundColor: '#fff',
  borderRadius: '0.625rem',
  border: '0.0625rem solid #E6E6E6',
  margin: '0.0625rem 1rem 0.625rem 1rem',
  width: 'auto',
  overflow: 'hidden',
})

export const Header = styled('div', {
  fontSize: '1rem',
  fontWeight: 600,
  color: '#222',
  backgroundColor: '#fff',
  padding: '0.7rem 1.2rem',
  borderBottom: '0.0625rem solid #E6E6E6',
})

export const GrayBlock = styled('div', {
  backgroundColor: '#f5f6fa',
  width: '100%',
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
  border: 0,
  borderRadius: 0,
})

export const GrayBlockContent = styled('div', {
  padding: '1.1rem 1.2rem',
})

export const List = styled('ul', {
  listStyle: 'none',
  padding: 0,
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
})

export const ListItem = styled('li', {
  fontSize: '1rem',
  color: '#222',
  lineHeight: 1.7,
  marginBottom: '0.7rem',
  '&:last-child': {
    marginBottom: 0,
  },
  '& b': {
    fontWeight: 600,
  },
})

export const LinkStyled = styled('a', {
  color: '#2583F6',
  textDecoration: 'underline',
  fontSize: '1rem',
  fontWeight: 400,
})

export const StyledHeaderEmpty = styled('div', () => ({}))

export const StyledEmptyMessageContainer = styled(FlexCenterY, {
  padding: '0rem 0.5rem 1rem 0.5rem',
})

export const StyledEmptyIcon = styled(FlexCenterY, {
  display: 'inline-flex',
  color: '#A9ABAE',
  fontSize: '1.6rem',
  marginRight: '0.15rem',
  justifyContent: 'center',
})

export const StyledEmptyText = styled('span', () => ({
  paddingTop: '0.45rem',
  color: '#58595B',
}))

export const StyledTopContainerEmpty = styled('div', () => ({
  padding: '1rem',
}))
